// extracted by mini-css-extract-plugin
export default {"container":"HideFunnelInStudentDetails_container__uYpnf"};